import React, { PureComponent } from 'react'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core'

class ConfirmationModal extends PureComponent {
  render() {
    const { open, close, title, keyOption, description, handleContinue } = this.props
    return (
      <Dialog open={open} className={'container-confirmation-modal'}>
        <DialogTitle>
          <span className={'title-confirmation-modal'}>{title}</span>
        </DialogTitle>
        <DialogContent>
          <span className={'description-confirmation-modal'}>{description}</span>
        </DialogContent>
        <DialogActions className={'container-buttons-adoption-mode'}>
          <Button onClick={close} className="button-white-and-red">
            <span className="button-text">Cancel</span>
          </Button>
          <Button onClick={() => handleContinue(keyOption)} className="button-blue-and-white">
            <span className="button-text">Continue</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ConfirmationModal.js